<div class="modal" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose('addModal')"></button>
			</div>
			<div class="modal-body">
				<table class="d-flex justify-content-center">
					<tbody>
						@for (item of driversSalaryWithCount()?.sumRates; track $index) {
							<tr>
								{{
									item?.name
								}}
								{{
									item?.count
								}}
								x
								{{
									item?.value | numberToDecimalStr
								}}
								{{
									item?.currency
								}}
							</tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="bonusPositive" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose('bonusPositive')"></button>
			</div>
			<div class="modal-body">
				<table class="d-flex justify-content-center">
					<tbody>
						@for (item of driversSalaryWithCount()?.sumBenefits; track $index) {
							<tr>
								{{
									item?.name
								}}
								{{
									item?.count
								}}
								x
								{{
									item?.value | numberToDecimalStr
								}}
								{{
									item?.currency
								}}
								-
								{{
									item?.month
								}}
								{{
									item?.comment
								}}
							</tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="bonusNegative" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose('bonusNegative')"></button>
			</div>
			<div class="modal-body">
				<table class="d-flex justify-content-center">
					<table class="d-flex justify-content-center">
						<tbody>
							@for (item of driversSalaryWithCount()?.sumDeduction; track $index) {
								<tr>
									{{
										item?.name
									}}
									{{
										item?.count
									}}
									x
									{{
										item?.value | numberToDecimalStr
									}}
									{{
										item?.currency
									}}
									{{
										item?.comment
									}}
									-
									{{
										item?.month
									}}
								</tr>
							}
						</tbody>
					</table>
				</table>
			</div>
		</div>
	</div>
</div>
